<template>
    <div>
		<b-row class="p-3"  v-on:click.stop>
			<b-col cols="12" v-for="fieldItem in salesFields" :key="fieldItem.key + 'field'">
				<b-checkbox v-if="fieldItem.changebale"  v-model="fieldItem.visible"> {{fieldItem.label}} </b-checkbox>
			</b-col>
		</b-row>
	</div>
</template>

<script>
    export default {
        name: 'VisibleColumns',

		props: {
        	defaultFields: {
        		type: Array,
				default: []
			}
		},
		data() {
        	return {
				salesFields: []
			}
		},
		created() {
        	this.fields = this.translateble(this.defaultFields);
		},
		methods: {
			translateble(columns = []) {
				return columns.filter(column => {
						column.label = this.$t(column.label);
						return column
				})
			},
		},
		watch: {
			fields: {
				handler() {
					this.$emit('result', this.defaultFields);
				},
				deep: true
			}
		}
    }
</script>

<style scoped>

</style>
